import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "LayoutGrid",
  "use": "LayoutGrid-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"LayoutGrid\">\n    <path d=\"M.5.5v6.667h6.667V.5H.5zm5 5H2.167V2.167H5.5V5.5zm-5 3.333V15.5h6.667V8.833H.5zm5 5H2.167V10.5H5.5v3.333zM8.833.5v6.667H15.5V.5H8.833zm5 5H10.5V2.167h3.333V5.5zm-5 3.333V15.5H15.5V8.833H8.833zm5 5H10.5V10.5h3.333v3.333z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol